import { render, staticRenderFns } from "./TerminalRegisterForm.vue?vue&type=template&id=6df23021&scoped=true"
import script from "./TerminalRegisterForm.vue?vue&type=script&lang=js"
export * from "./TerminalRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df23021",
  null
  
)

export default component.exports